module.exports = __webpack_public_path__ + "static/Ada-232427cd46416d1efab991a9f2988d1b.png";